import { AuthProvider } from '../state/auth';
import { ToastProvider } from '../state/toast';
import { SheetHost } from '../components/ui/Sheet';
import { Shell } from './Shell';

export function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <SheetHost>
          <Shell />
        </SheetHost>
      </AuthProvider>
    </ToastProvider>
  );
}
